/* eslint-disable */
import classNames from 'classnames';
import omit from 'lodash.omit';

import React, {useState} from 'react';

import {
    defineMessages,
    injectIntl,
} from 'react-intl';
import {connect} from 'react-redux';

import tabStyles from 'react-tabs/style/react-tabs.css';

import Renderer from 'scratch-render';


import { P3G } from './p3g_gui.jsx';
import { CDG1 } from './cdg1_gui.jsx';



import Box from '../box/box.jsx';


import styles from './gui.css';



import RobotBlocksGui from './robot_blocks_gui.jsx';

const messages = defineMessages({
    addExtension: {
        id: 'gui.gui.addExtension',
        description: 'Button to add an extension in the target pane',
        defaultMessage: 'Add Extension'
    }
});

// Cache this value to only retrieve it once the first time.
// Assume that it doesn't change for a session.
let isRendererSupported = null;

const GUIComponent = props => {
    const {
        accountNavOpen,
        activeTabIndex,
        alertsVisible,
        authorId,
        authorThumbnailUrl,
        authorUsername,
        basePath,
        backdropLibraryVisible,
        backpackHost,
        backpackVisible,
        blocksTabVisible,
        cardsVisible,
        canChangeLanguage,
        canCreateNew,
        canEditTitle,
        canManageFiles,
        canRemix,
        canSave,
        canCreateCopy,
        canShare,
        canUseCloud,
        children,
        connectionModalVisible,
        costumeLibraryVisible,
        costumesTabVisible,
        enableCommunity,
        intl,
        isCreating,
        isFullScreen,
        isPlayerOnly,
        isRtl,
        isShared,
        loading,
        layout,
        logo,
        renderLogin,
        onClickAbout,
        onClickAccountNav,
        onCloseAccountNav,
        onLogOut,
        onOpenRegistration,
        onToggleLoginOpen,
        onActivateCostumesTab,
        onActivateSoundsTab,
        onActivateTab,
        onClickLogo,
        onExtensionButtonClick,
        onProjectTelemetryEvent,
        onRequestCloseBackdropLibrary,
        onRequestCloseCostumeLibrary,
        onRequestCloseTelemetryModal,
        onSeeCommunity,
        onShare,
        onShowPrivacyPolicy,
        onTelemetryModalCancel,
        onTelemetryModalOptIn,
        onTelemetryModalOptOut,
        showComingSoon,
        soundsTabVisible,
        stageSizeMode,
        targetIsStage,
        telemetryModalVisible,
        tipsLibraryVisible,
        vm,
        scratch,
        ...componentProps
    } = omit(props, 'dispatch');
    if (children) {
        return <Box {...componentProps}>{children}</Box>;
    }

    const tabClassNames = {
        tabs: styles.tabs,
        tab: classNames(tabStyles.reactTabsTab, styles.tab),
        tabList: classNames(tabStyles.reactTabsTabList, styles.tabList),
        tabPanel: classNames(tabStyles.reactTabsTabPanel, styles.tabPanel),
        tabPanelSelected: classNames(
            tabStyles.reactTabsTabPanelSelected,
            styles.isSelected,
        ),
        tabSelected: classNames(
            tabStyles.reactTabsTabSelected,
            styles.isSelected,
        )
    };

    if (isRendererSupported === null) {
        isRendererSupported = Renderer.isSupported();
    }
    const openPI = () => {
        console.log("Open_pi");
        setPIActive(true);
    }
    // const getSaveToComputerHandler = downloadProjectCallback => () => {
    //     downloadProjectCallback();

    //     // this.props.onRequestCloseFile();
    //     // if (this.props.onProjectTelemetryEvent) {
    //     //     const metadata = collectMetadata(this.props.vm, this.props.projectTitle, this.props.locale);
    //     //     this.props.onProjectTelemetryEvent('projectDidSave', metadata);
    //     // }
    // };

    const [piActive, setPIActive] = useState(false);

    return (
                <CDG1
                canUseCloud={canUseCloud}
                blocksTabVisible={blocksTabVisible}
                basePath={basePath}
                vm={vm}
                stageSizeMode={stageSizeMode}
                layout={layout}
                scratchGui ={scratch}        
            /> 
        
    );
};


GUIComponent.defaultProps = {
    backpackHost: null,
    backpackVisible: false,
    basePath: './',
    canChangeLanguage: true,
    canCreateNew: false,
    canEditTitle: false,
    canManageFiles: true,
    canRemix: false,
    canSave: true,
    canCreateCopy: false,
    canShare: false,
    canUseCloud: false,
    enableCommunity: false,
    isCreating: false,
    isShared: false,
    loading: false,
    showComingSoon: false,
    stageSizeMode: 0,
    scratchGui: null
};

const mapStateToProps = state => ({
    // This is the button's mode, as opposed to the actual current state
    stageSizeMode: state.scratchGui.stageSize.stageSize,
    scratch: state.scratchGui,
});

export default injectIntl(connect(mapStateToProps)(GUIComponent));
